const mobileMenu = () => {
  const hamburger = document.querySelector('.js-hamburger');
  const navigation = document.querySelector('.js-navigation');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('m-hamburger--toggled');
    navigation.classList.toggle('is-active');
  })
};

export default mobileMenu;
